var modules_436816d0 = {"container":"_thtd88","rotate":"_1egw2jv","svg":"_9mffe2","loading":"_1v0isrp","circle":"_1v96q6y","circle-1":"_t1h4fo","circle-2":"_j9sxus","loading-circle":"_1ix5zke","size-16":"_15pk5zn","size-20":"_1gwwq7x","size-24":"_guldtq","size-28":"_xb5sem"};
import "../../../assets/Ehi4z4OV.css";

export { modules_436816d0 as default };
//# sourceMappingURL=Spinner.module.less.js.map
